import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import { AppSearchSelect, AppInput } from "../../../components/appComponents";
import AddExpense from "./components/addexpense";

const Expenses = () => {
  const [data, setData] = useState({});
  let [fromDate, setfromDate] = useState(null);
  let [tillDate, settillDate] = useState(null);
  const [expenseHeadId, setexpenseHeadId] = useState(null);
  const [accountList, setAccountList] = useState([]);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);
  //const [clubaccountId, setclubaccountId] = useState(null);
  //const [paymentTypeList, setPaymentTypeList] = useState([]);

  useEffect(() => {
    getData(1);
    getExpenseAccount();
    /*     getClubPaymentTypes();*/
  }, []);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open]);

  useEffect(() => {
    getData(1);
    getExpenseAccount();
    /*   getClubPaymentTypes();*/
  }, [expenseHeadId, fromDate, tillDate /*clubaccountId*/]);

  const resetFilters = () => {
    setfromDate(null);
    settillDate(null);
    setexpenseHeadId(null);
    /*    clubaccountId(null);*/
  };

  //const getClubPaymentTypes = async () => {
  //    const response = await Common.ApiService.getInstance().request(
  //        "GetClubPaymentTypes?isForReport=false"
  //    );

  //    if (response?.status == respEnum.Success) {
  //        setPaymentTypeList(response?.data ?? []);
  //    }
  //};

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    if (fromDate == "") {
      fromDate = null;
    }
    if (tillDate == "") {
      tillDate = null;
    }

    const response = await Common.ApiService.getInstance().request(
      "GetExpense",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        expenseHeadId: expenseHeadId,
        fromDate,
        tillDate,
        //clubaccountId: clubaccountId ? clubaccountId.value : null,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          createdOn: Common.Utility.ConvertTime(item.createdOn),
          updatedOn: Common.Utility.ConvertTime(item.updatedOn),
        })),
      };

      setData(obj);
    }
  };

  const getExpenseAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetExpenseAccounts"
      );
      const data = [{ id: null, name: "All" }, ...(response?.data ?? [])];

      setAccountList(data);
    });
  };

  
  const columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Expense Type",
      type: "text",
      isVisible: true,
      key: "expenseAccount",
    },
    { title: "Expense", type: "text", isVisible: true, key: "name" },
    {
      title: "Amount",
      type: "number",
      isVisible: true,
      key: "amount",
      showTotal: true,

    },
    { title: "Description", type: "text", isVisible: true, key: "desc" },
    { title: "Created On", type: "text", isVisible: true, key: "createdOn" },
    { title: "Updated On", type: "text", isVisible: true, key: "updatedOn" },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Expense?",
      "Delete Expense"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteExpense?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  return (
    <>
      <div className="md:grid md:grid-cols-6 gap-3 ">
        <AppInput
          type={"date"}
          value={fromDate}
          onChange={(e) => {
            const selectedstartDate = e;
            if (tillDate && selectedstartDate > tillDate) {
              Common.showToast(
                "From Date must be lesser than till Date",
                "Error",
                "info"
              );
              setfromDate(null);
            } else {
              setfromDate(selectedstartDate);
            }
          }}
          label="From"
          className="mb-3 col-span-1"
        />

        <AppInput
          type={"date"}
          value={tillDate}
          onChange={(e) => {
            const selectedEndDate = e;
            if (selectedEndDate < fromDate) {
              Common.showToast("Till Date must be greater", "Error", "info");
              settillDate("");
            } else {
              settillDate(selectedEndDate);
            }
          }}
          label="Till"
          className="mb-3 col-span-1"
        />

        <AppSearchSelect
          value={expenseHeadId}
          onChange={setexpenseHeadId}
          placeholder={"All"}
          label={"Expense Account"}
          data={accountList}
          className={"mb-3 col-span-1"}
        />

        {/*<AppSearchSectionSelect*/}
        {/*    value={clubaccountId}*/}
        {/*    onChange={setclubaccountId}*/}
        {/*    label="Account"*/}
        {/*    data={paymentTypeList}*/}
        {/*    className="mb-5 col-span-1"*/}
        {/*/>*/}
        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Expenses"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          showPagination
          showAddButton
          actionButtons={actions}
          addButton={() => (
            <AddExpense
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default Expenses;
